import {normalize, searchIndex, filterIndex} from '@/utils/timesheetEmployeeSearch';

export default {
    data: () => ({employeeSearchText: '', employeeSearchQuery: '', employeeSearchNotice: ''}),
    computed: {
        employeeSearchIndex() { return searchIndex(this.sortedLines); },
        filteredLines() { return filterIndex(this.employeeSearchIndex, this.employeeSearchQuery); },
        employeeSearchActive() { return Boolean(normalize(this.employeeSearchText) || this.employeeSearchQuery); },
        employeeSearchPending() { return normalize(this.employeeSearchText) !== this.employeeSearchQuery; },
        employeeSearchContext() {
            const user = this.$store.getters.currentUser || {};
            return [user.company, this.sheet && this.sheet.timesheet.id, this.periodMonth, this.buildingId].join(':');
        },
        bulkRecipientLabel() {
            if (this.employeeSearchPending) return 'По результатам поиска — поставить';
            return this.employeeSearchActive ? `Найденным: ${this.filteredLines.length} — поставить` : 'всем поставить';
        },
        bulkFillDisabled() {
            return this.loading || this.periodNavigationLocked || (!this.employeeSearchPending && !this.filteredLines.length);
        }
    },
    watch: {
        employeeSearchContext() { this.resetEmployeeSearch(); }
    },
    beforeDestroy() { this.cancelEmployeeSearchTimer(); },
    methods: {
        cancelEmployeeSearchTimer() {
            clearTimeout(this._employeeSearchTimer);
            this._employeeSearchTimer = null;
        },
        changeEmployeeSearch(value) {
            this.employeeSearchText = value;
            this.employeeSearchNotice = '';
            this.cancelEmployeeSearchTimer();
            this._employeeSearchTimer = setTimeout(() => this.flushEmployeeSearch(), 150);
        },
        flushEmployeeSearch() {
            this.cancelEmployeeSearchTimer();
            const query = normalize(this.employeeSearchText);
            if (query === this.employeeSearchQuery) return;
            if (this._cellPicker) this._cellPicker.clear();
            this.employeeSearchQuery = query;
            const context = this.employeeSearchContext;
            this.$nextTick(() => {
                if (this._isDestroyed || context !== this.employeeSearchContext || query !== this.employeeSearchQuery) return;
                const viewport = this.$refs.monthScroll;
                if (viewport) viewport.scrollTop = 0;
                if (this.$refs.monthRows) this.$refs.monthRows.schedule();
            });
        },
        resetEmployeeSearch() {
            this.employeeSearchText = '';
            this.employeeSearchNotice = '';
            this.flushEmployeeSearch();
        },
        revealEmployeeSearchLine(lineId) {
            // Include a pending query: it must not hide the target after navigation.
            const line = this.sortedLines.find(item => Number(item.id) === Number(lineId));
            if (!line) return;
            const found = filterIndex(searchIndex([line]), this.employeeSearchText).length;
            if (found && this.filteredLines.some(item => Number(item.id) === Number(lineId))) return;
            this.resetEmployeeSearch();
            this.employeeSearchNotice = `Фильтр снят, чтобы показать: ${line.employee_name_snapshot}.`;
        },
        captureTimesheetBulkAction() {
            this.flushEmployeeSearch();
            return {
                sheetId: this.currentTimesheetId(), date: this.selectedDate, value: this.bulkValue,
                lines: this.filteredLines.slice()
            };
        },
        showEmployeeSearchProblem(key) {
            const record = this._editQueue && this._editQueue.records.get(key);
            const line = record && this.sortedLines.find(item => Number(item.id) === Number(record.meta.lineId));
            if (!line) return;
            this.revealEmployeeSearchLine(line.id);
            if (record.meta.date) this.openIssueGroup(line, record.meta.date);
            else this.openAssessment(line);
        }
    }
};
